import { type SVGProps } from "react"
import { css } from "@octopus-energy/coral-design/css"

const wrapperClass = css({
    position: "relative",
    _after: {
        content: " ",
        position: "absolute",
        width: "100%",
        height: "50%",
        background: "linear-gradient(180deg, rgba(16, 0, 48, 0) 0%, #100030 100%)",
        animation: "OEFRWaveFade 3s infinite",
        zIndex: 1,
        left: 0,
        bottom: 0,
    },
})

function GreenHousesFadingSmall(props: SVGProps<SVGSVGElement>) {
    return (
        <div className={wrapperClass}>
            <svg
                width="64"
                height="112"
                viewBox="0 0 64 112"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <g
                    opacity="0.8"
                    clipPath="url(#clip0_484_5137)"
                >
                    <path
                        d="M8.00526 0L0 6.96504V22.0108H16.0105V6.96504L8.00526 0ZM11.243 12.3811C11.1172 12.6194 10.981 12.8469 10.8448 13.0852L10.038 14.5042L9.09497 16.1615L8.33006 17.5263C8.2148 17.7105 8.11004 17.9055 8.00526 18.0896C7.96204 18.1674 7.9032 18.2347 7.83271 18.287C7.76223 18.3393 7.68171 18.3754 7.5966 18.3929H7.47087C7.35619 18.4033 7.24155 18.3727 7.14606 18.3063C7.02374 18.2291 6.93114 18.1104 6.88411 17.9705C6.8635 17.9039 6.8529 17.8345 6.85267 17.7646V14.6125H5.29142C5.18345 14.6097 5.078 14.5782 4.98524 14.5209C4.89248 14.4637 4.81554 14.3828 4.76184 14.2859C4.70814 14.189 4.67949 14.0795 4.67865 13.9678C4.67781 13.8562 4.70482 13.7462 4.75706 13.6484C4.76754 13.6484 4.76752 13.6484 4.76752 13.6376L5.16569 12.9444C5.42764 12.4677 5.70007 11.9911 5.9725 11.5254L6.90506 9.86804L7.68043 8.5032L8.00526 7.93993C8.07657 7.81949 8.1828 7.72536 8.30883 7.67091C8.43486 7.61647 8.57428 7.60447 8.70728 7.63663C8.83645 7.67608 8.94995 7.75736 9.03106 7.86852C9.11218 7.97968 9.15663 8.11483 9.15784 8.25406V11.4062H10.7191C10.829 11.4066 10.9368 11.4372 11.0314 11.495C11.126 11.5528 11.204 11.6356 11.2574 11.7349C11.3108 11.8342 11.3376 11.9465 11.335 12.06C11.3325 12.1736 11.3007 12.2844 11.243 12.3811Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip1_484_5137)"
                >
                    <path
                        d="M8.00526 30L0 36.965V52.0108H16.0105V36.965L8.00526 30ZM11.243 42.3811C11.1172 42.6194 10.981 42.8469 10.8448 43.0852L10.038 44.5042L9.09497 46.1615L8.33006 47.5263C8.2148 47.7105 8.11004 47.9055 8.00526 48.0896C7.96204 48.1674 7.9032 48.2347 7.83271 48.287C7.76223 48.3393 7.68171 48.3754 7.5966 48.3929H7.47087C7.35619 48.4033 7.24155 48.3727 7.14606 48.3063C7.02374 48.2291 6.93114 48.1104 6.88411 47.9705C6.8635 47.9039 6.8529 47.8345 6.85267 47.7646V44.6125H5.29142C5.18345 44.6097 5.078 44.5782 4.98524 44.5209C4.89248 44.4637 4.81554 44.3828 4.76184 44.2859C4.70814 44.189 4.67949 44.0795 4.67865 43.9678C4.67781 43.8562 4.70482 43.7462 4.75706 43.6484C4.76754 43.6484 4.76752 43.6484 4.76752 43.6376L5.16569 42.9444C5.42764 42.4677 5.70007 41.9911 5.9725 41.5254L6.90506 39.868L7.68043 38.5032L8.00526 37.9399C8.07657 37.8195 8.1828 37.7254 8.30883 37.6709C8.43486 37.6165 8.57428 37.6045 8.70728 37.6366C8.83645 37.6761 8.94995 37.7574 9.03106 37.8685C9.11218 37.9797 9.15663 38.1148 9.15784 38.2541V41.4062H10.7191C10.829 41.4066 10.9368 41.4372 11.0314 41.495C11.126 41.5528 11.204 41.6356 11.2574 41.7349C11.3108 41.8342 11.3376 41.9465 11.335 42.06C11.3325 42.1736 11.3007 42.2844 11.243 42.3811Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip2_484_5137)"
                >
                    <path
                        d="M8.00526 60L0 66.965V82.0108H16.0105V66.965L8.00526 60ZM11.243 72.3811C11.1172 72.6194 10.981 72.8469 10.8448 73.0852L10.038 74.5042L9.09497 76.1615L8.33006 77.5263C8.2148 77.7105 8.11004 77.9055 8.00526 78.0896C7.96204 78.1674 7.9032 78.2347 7.83271 78.287C7.76223 78.3393 7.68171 78.3754 7.5966 78.3929H7.47087C7.35619 78.4033 7.24155 78.3727 7.14606 78.3063C7.02374 78.2291 6.93114 78.1104 6.88411 77.9705C6.8635 77.9039 6.8529 77.8345 6.85267 77.7646V74.6125H5.29142C5.18345 74.6097 5.078 74.5782 4.98524 74.5209C4.89248 74.4637 4.81554 74.3828 4.76184 74.2859C4.70814 74.189 4.67949 74.0795 4.67865 73.9678C4.67781 73.8562 4.70482 73.7462 4.75706 73.6484C4.76754 73.6484 4.76752 73.6484 4.76752 73.6376L5.16569 72.9444C5.42764 72.4677 5.70007 71.9911 5.9725 71.5254L6.90506 69.868L7.68043 68.5032L8.00526 67.9399C8.07657 67.8195 8.1828 67.7254 8.30883 67.6709C8.43486 67.6165 8.57428 67.6045 8.70728 67.6366C8.83645 67.6761 8.94995 67.7574 9.03106 67.8685C9.11218 67.9797 9.15663 68.1148 9.15784 68.2541V71.4062H10.7191C10.829 71.4066 10.9368 71.4372 11.0314 71.495C11.126 71.5528 11.204 71.6356 11.2574 71.7349C11.3108 71.8342 11.3376 71.9465 11.335 72.06C11.3325 72.1736 11.3007 72.2844 11.243 72.3811Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip3_484_5137)"
                >
                    <path
                        d="M8.00526 90L0 96.965V112.011H16.0105V96.965L8.00526 90ZM11.243 102.381C11.1172 102.619 10.981 102.847 10.8448 103.085L10.038 104.504L9.09497 106.161L8.33006 107.526C8.2148 107.71 8.11004 107.905 8.00526 108.09C7.96204 108.167 7.9032 108.235 7.83271 108.287C7.76223 108.339 7.68171 108.375 7.5966 108.393H7.47087C7.35619 108.403 7.24155 108.373 7.14606 108.306C7.02374 108.229 6.93114 108.11 6.88411 107.97C6.8635 107.904 6.8529 107.835 6.85267 107.765V104.613H5.29142C5.18345 104.61 5.078 104.578 4.98524 104.521C4.89248 104.464 4.81554 104.383 4.76184 104.286C4.70814 104.189 4.67949 104.079 4.67865 103.968C4.67781 103.856 4.70482 103.746 4.75706 103.648C4.76754 103.648 4.76752 103.648 4.76752 103.638L5.16569 102.944C5.42764 102.468 5.70007 101.991 5.9725 101.525L6.90506 99.868L7.68043 98.5032L8.00526 97.9399C8.07657 97.8195 8.1828 97.7254 8.30883 97.6709C8.43486 97.6165 8.57428 97.6045 8.70728 97.6366C8.83645 97.6761 8.94995 97.7574 9.03106 97.8685C9.11218 97.9797 9.15663 98.1148 9.15784 98.2541V101.406H10.7191C10.829 101.407 10.9368 101.437 11.0314 101.495C11.126 101.553 11.204 101.636 11.2574 101.735C11.3108 101.834 11.3376 101.946 11.335 102.06C11.3325 102.174 11.3007 102.284 11.243 102.381Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip4_484_5137)"
                >
                    <path
                        d="M32.0053 0L24 6.96504V22.0108H40.0105V6.96504L32.0053 0ZM35.243 12.3811C35.1172 12.6194 34.981 12.8469 34.8448 13.0852L34.038 14.5042L33.095 16.1615L32.3301 17.5263C32.2148 17.7105 32.11 17.9055 32.0053 18.0896C31.962 18.1674 31.9032 18.2347 31.8327 18.287C31.7622 18.3393 31.6817 18.3754 31.5966 18.3929H31.4709C31.3562 18.4033 31.2416 18.3727 31.1461 18.3063C31.0237 18.2291 30.9311 18.1104 30.8841 17.9705C30.8635 17.9039 30.8529 17.8345 30.8527 17.7646V14.6125H29.2914C29.1834 14.6097 29.078 14.5782 28.9852 14.5209C28.8925 14.4637 28.8155 14.3828 28.7618 14.2859C28.7081 14.189 28.6795 14.0795 28.6787 13.9678C28.6778 13.8562 28.7048 13.7462 28.7571 13.6484C28.7675 13.6484 28.7675 13.6484 28.7675 13.6376L29.1657 12.9444C29.4276 12.4677 29.7001 11.9911 29.9725 11.5254L30.9051 9.86804L31.6804 8.5032L32.0053 7.93993C32.0766 7.81949 32.1828 7.72536 32.3088 7.67091C32.4349 7.61647 32.5743 7.60447 32.7073 7.63663C32.8365 7.67608 32.9499 7.75736 33.0311 7.86852C33.1122 7.97968 33.1566 8.11483 33.1578 8.25406V11.4062H34.7191C34.829 11.4066 34.9368 11.4372 35.0314 11.495C35.126 11.5528 35.204 11.6356 35.2574 11.7349C35.3108 11.8342 35.3376 11.9465 35.335 12.06C35.3325 12.1736 35.3007 12.2844 35.243 12.3811Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip5_484_5137)"
                >
                    <path
                        d="M32.0053 30L24 36.965V52.0108H40.0105V36.965L32.0053 30ZM35.243 42.3811C35.1172 42.6194 34.981 42.8469 34.8448 43.0852L34.038 44.5042L33.095 46.1615L32.3301 47.5263C32.2148 47.7105 32.11 47.9055 32.0053 48.0896C31.962 48.1674 31.9032 48.2347 31.8327 48.287C31.7622 48.3393 31.6817 48.3754 31.5966 48.3929H31.4709C31.3562 48.4033 31.2416 48.3727 31.1461 48.3063C31.0237 48.2291 30.9311 48.1104 30.8841 47.9705C30.8635 47.9039 30.8529 47.8345 30.8527 47.7646V44.6125H29.2914C29.1834 44.6097 29.078 44.5782 28.9852 44.5209C28.8925 44.4637 28.8155 44.3828 28.7618 44.2859C28.7081 44.189 28.6795 44.0795 28.6787 43.9678C28.6778 43.8562 28.7048 43.7462 28.7571 43.6484C28.7675 43.6484 28.7675 43.6484 28.7675 43.6376L29.1657 42.9444C29.4276 42.4677 29.7001 41.9911 29.9725 41.5254L30.9051 39.868L31.6804 38.5032L32.0053 37.9399C32.0766 37.8195 32.1828 37.7254 32.3088 37.6709C32.4349 37.6165 32.5743 37.6045 32.7073 37.6366C32.8365 37.6761 32.9499 37.7574 33.0311 37.8685C33.1122 37.9797 33.1566 38.1148 33.1578 38.2541V41.4062H34.7191C34.829 41.4066 34.9368 41.4372 35.0314 41.495C35.126 41.5528 35.204 41.6356 35.2574 41.7349C35.3108 41.8342 35.3376 41.9465 35.335 42.06C35.3325 42.1736 35.3007 42.2844 35.243 42.3811Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip6_484_5137)"
                >
                    <path
                        d="M32.0053 60L24 66.965V82.0108H40.0105V66.965L32.0053 60ZM35.243 72.3811C35.1172 72.6194 34.981 72.8469 34.8448 73.0852L34.038 74.5042L33.095 76.1615L32.3301 77.5263C32.2148 77.7105 32.11 77.9055 32.0053 78.0896C31.962 78.1674 31.9032 78.2347 31.8327 78.287C31.7622 78.3393 31.6817 78.3754 31.5966 78.3929H31.4709C31.3562 78.4033 31.2416 78.3727 31.1461 78.3063C31.0237 78.2291 30.9311 78.1104 30.8841 77.9705C30.8635 77.9039 30.8529 77.8345 30.8527 77.7646V74.6125H29.2914C29.1834 74.6097 29.078 74.5782 28.9852 74.5209C28.8925 74.4637 28.8155 74.3828 28.7618 74.2859C28.7081 74.189 28.6795 74.0795 28.6787 73.9678C28.6778 73.8562 28.7048 73.7462 28.7571 73.6484C28.7675 73.6484 28.7675 73.6484 28.7675 73.6376L29.1657 72.9444C29.4276 72.4677 29.7001 71.9911 29.9725 71.5254L30.9051 69.868L31.6804 68.5032L32.0053 67.9399C32.0766 67.8195 32.1828 67.7254 32.3088 67.6709C32.4349 67.6165 32.5743 67.6045 32.7073 67.6366C32.8365 67.6761 32.9499 67.7574 33.0311 67.8685C33.1122 67.9797 33.1566 68.1148 33.1578 68.2541V71.4062H34.7191C34.829 71.4066 34.9368 71.4372 35.0314 71.495C35.126 71.5528 35.204 71.6356 35.2574 71.7349C35.3108 71.8342 35.3376 71.9465 35.335 72.06C35.3325 72.1736 35.3007 72.2844 35.243 72.3811Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip7_484_5137)"
                >
                    <path
                        d="M32.0053 90L24 96.965V112.011H40.0105V96.965L32.0053 90ZM35.243 102.381C35.1172 102.619 34.981 102.847 34.8448 103.085L34.038 104.504L33.095 106.161L32.3301 107.526C32.2148 107.71 32.11 107.905 32.0053 108.09C31.962 108.167 31.9032 108.235 31.8327 108.287C31.7622 108.339 31.6817 108.375 31.5966 108.393H31.4709C31.3562 108.403 31.2416 108.373 31.1461 108.306C31.0237 108.229 30.9311 108.11 30.8841 107.97C30.8635 107.904 30.8529 107.835 30.8527 107.765V104.613H29.2914C29.1834 104.61 29.078 104.578 28.9852 104.521C28.8925 104.464 28.8155 104.383 28.7618 104.286C28.7081 104.189 28.6795 104.079 28.6787 103.968C28.6778 103.856 28.7048 103.746 28.7571 103.648C28.7675 103.648 28.7675 103.648 28.7675 103.638L29.1657 102.944C29.4276 102.468 29.7001 101.991 29.9725 101.525L30.9051 99.868L31.6804 98.5032L32.0053 97.9399C32.0766 97.8195 32.1828 97.7254 32.3088 97.6709C32.4349 97.6165 32.5743 97.6045 32.7073 97.6366C32.8365 97.6761 32.9499 97.7574 33.0311 97.8685C33.1122 97.9797 33.1566 98.1148 33.1578 98.2541V101.406H34.7191C34.829 101.407 34.9368 101.437 35.0314 101.495C35.126 101.553 35.204 101.636 35.2574 101.735C35.3108 101.834 35.3376 101.946 35.335 102.06C35.3325 102.174 35.3007 102.284 35.243 102.381Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip8_484_5137)"
                >
                    <path
                        d="M56.0053 0L48 6.96504V22.0108H64.0105V6.96504L56.0053 0ZM59.243 12.3811C59.1172 12.6194 58.981 12.8469 58.8448 13.0852L58.038 14.5042L57.095 16.1615L56.3301 17.5263C56.2148 17.7105 56.11 17.9055 56.0053 18.0896C55.962 18.1674 55.9032 18.2347 55.8327 18.287C55.7622 18.3393 55.6817 18.3754 55.5966 18.3929H55.4709C55.3562 18.4033 55.2416 18.3727 55.1461 18.3063C55.0237 18.2291 54.9311 18.1104 54.8841 17.9705C54.8635 17.9039 54.8529 17.8345 54.8527 17.7646V14.6125H53.2914C53.1834 14.6097 53.078 14.5782 52.9852 14.5209C52.8925 14.4637 52.8155 14.3828 52.7618 14.2859C52.7081 14.189 52.6795 14.0795 52.6787 13.9678C52.6778 13.8562 52.7048 13.7462 52.7571 13.6484C52.7675 13.6484 52.7675 13.6484 52.7675 13.6376L53.1657 12.9444C53.4276 12.4677 53.7001 11.9911 53.9725 11.5254L54.9051 9.86804L55.6804 8.5032L56.0053 7.93993C56.0766 7.81949 56.1828 7.72536 56.3088 7.67091C56.4349 7.61647 56.5743 7.60447 56.7073 7.63663C56.8365 7.67608 56.9499 7.75736 57.0311 7.86852C57.1122 7.97968 57.1566 8.11483 57.1578 8.25406V11.4062H58.7191C58.829 11.4066 58.9368 11.4372 59.0314 11.495C59.126 11.5528 59.204 11.6356 59.2574 11.7349C59.3108 11.8342 59.3376 11.9465 59.335 12.06C59.3325 12.1736 59.3007 12.2844 59.243 12.3811Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip9_484_5137)"
                >
                    <path
                        d="M56.0053 30L48 36.965V52.0108H64.0105V36.965L56.0053 30ZM59.243 42.3811C59.1172 42.6194 58.981 42.8469 58.8448 43.0852L58.038 44.5042L57.095 46.1615L56.3301 47.5263C56.2148 47.7105 56.11 47.9055 56.0053 48.0896C55.962 48.1674 55.9032 48.2347 55.8327 48.287C55.7622 48.3393 55.6817 48.3754 55.5966 48.3929H55.4709C55.3562 48.4033 55.2416 48.3727 55.1461 48.3063C55.0237 48.2291 54.9311 48.1104 54.8841 47.9705C54.8635 47.9039 54.8529 47.8345 54.8527 47.7646V44.6125H53.2914C53.1834 44.6097 53.078 44.5782 52.9852 44.5209C52.8925 44.4637 52.8155 44.3828 52.7618 44.2859C52.7081 44.189 52.6795 44.0795 52.6787 43.9678C52.6778 43.8562 52.7048 43.7462 52.7571 43.6484C52.7675 43.6484 52.7675 43.6484 52.7675 43.6376L53.1657 42.9444C53.4276 42.4677 53.7001 41.9911 53.9725 41.5254L54.9051 39.868L55.6804 38.5032L56.0053 37.9399C56.0766 37.8195 56.1828 37.7254 56.3088 37.6709C56.4349 37.6165 56.5743 37.6045 56.7073 37.6366C56.8365 37.6761 56.9499 37.7574 57.0311 37.8685C57.1122 37.9797 57.1566 38.1148 57.1578 38.2541V41.4062H58.7191C58.829 41.4066 58.9368 41.4372 59.0314 41.495C59.126 41.5528 59.204 41.6356 59.2574 41.7349C59.3108 41.8342 59.3376 41.9465 59.335 42.06C59.3325 42.1736 59.3007 42.2844 59.243 42.3811Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip10_484_5137)"
                >
                    <path
                        d="M56.0053 60L48 66.965V82.0108H64.0105V66.965L56.0053 60ZM59.243 72.3811C59.1172 72.6194 58.981 72.8469 58.8448 73.0852L58.038 74.5042L57.095 76.1615L56.3301 77.5263C56.2148 77.7105 56.11 77.9055 56.0053 78.0896C55.962 78.1674 55.9032 78.2347 55.8327 78.287C55.7622 78.3393 55.6817 78.3754 55.5966 78.3929H55.4709C55.3562 78.4033 55.2416 78.3727 55.1461 78.3063C55.0237 78.2291 54.9311 78.1104 54.8841 77.9705C54.8635 77.9039 54.8529 77.8345 54.8527 77.7646V74.6125H53.2914C53.1834 74.6097 53.078 74.5782 52.9852 74.5209C52.8925 74.4637 52.8155 74.3828 52.7618 74.2859C52.7081 74.189 52.6795 74.0795 52.6787 73.9678C52.6778 73.8562 52.7048 73.7462 52.7571 73.6484C52.7675 73.6484 52.7675 73.6484 52.7675 73.6376L53.1657 72.9444C53.4276 72.4677 53.7001 71.9911 53.9725 71.5254L54.9051 69.868L55.6804 68.5032L56.0053 67.9399C56.0766 67.8195 56.1828 67.7254 56.3088 67.6709C56.4349 67.6165 56.5743 67.6045 56.7073 67.6366C56.8365 67.6761 56.9499 67.7574 57.0311 67.8685C57.1122 67.9797 57.1566 68.1148 57.1578 68.2541V71.4062H58.7191C58.829 71.4066 58.9368 71.4372 59.0314 71.495C59.126 71.5528 59.204 71.6356 59.2574 71.7349C59.3108 71.8342 59.3376 71.9465 59.335 72.06C59.3325 72.1736 59.3007 72.2844 59.243 72.3811Z"
                        fill="#18F0B8"
                    />
                </g>
                <g
                    opacity="0.8"
                    clipPath="url(#clip11_484_5137)"
                >
                    <path
                        d="M56.0053 90L48 96.965V112.011H64.0105V96.965L56.0053 90ZM59.243 102.381C59.1172 102.619 58.981 102.847 58.8448 103.085L58.038 104.504L57.095 106.161L56.3301 107.526C56.2148 107.71 56.11 107.905 56.0053 108.09C55.962 108.167 55.9032 108.235 55.8327 108.287C55.7622 108.339 55.6817 108.375 55.5966 108.393H55.4709C55.3562 108.403 55.2416 108.373 55.1461 108.306C55.0237 108.229 54.9311 108.11 54.8841 107.97C54.8635 107.904 54.8529 107.835 54.8527 107.765V104.613H53.2914C53.1834 104.61 53.078 104.578 52.9852 104.521C52.8925 104.464 52.8155 104.383 52.7618 104.286C52.7081 104.189 52.6795 104.079 52.6787 103.968C52.6778 103.856 52.7048 103.746 52.7571 103.648C52.7675 103.648 52.7675 103.648 52.7675 103.638L53.1657 102.944C53.4276 102.468 53.7001 101.991 53.9725 101.525L54.9051 99.868L55.6804 98.5032L56.0053 97.9399C56.0766 97.8195 56.1828 97.7254 56.3088 97.6709C56.4349 97.6165 56.5743 97.6045 56.7073 97.6366C56.8365 97.6761 56.9499 97.7574 57.0311 97.8685C57.1122 97.9797 57.1566 98.1148 57.1578 98.2541V101.406H58.7191C58.829 101.407 58.9368 101.437 59.0314 101.495C59.126 101.553 59.204 101.636 59.2574 101.735C59.3108 101.834 59.3376 101.946 59.335 102.06C59.3325 102.174 59.3007 102.284 59.243 102.381Z"
                        fill="#18F0B8"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                        />
                    </clipPath>
                    <clipPath id="clip1_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(0 30)"
                        />
                    </clipPath>
                    <clipPath id="clip2_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(0 60)"
                        />
                    </clipPath>
                    <clipPath id="clip3_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(0 90)"
                        />
                    </clipPath>
                    <clipPath id="clip4_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(24)"
                        />
                    </clipPath>
                    <clipPath id="clip5_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(24 30)"
                        />
                    </clipPath>
                    <clipPath id="clip6_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(24 60)"
                        />
                    </clipPath>
                    <clipPath id="clip7_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(24 90)"
                        />
                    </clipPath>
                    <clipPath id="clip8_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(48)"
                        />
                    </clipPath>
                    <clipPath id="clip9_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(48 30)"
                        />
                    </clipPath>
                    <clipPath id="clip10_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(48 60)"
                        />
                    </clipPath>
                    <clipPath id="clip11_484_5137">
                        <rect
                            width="16"
                            height="22"
                            fill="white"
                            transform="translate(48 90)"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}

export function GreenHousesFading(props: SVGProps<SVGSVGElement>) {
    return (
        <div className={wrapperClass}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={64}
                height={234}
                fill="none"
                {...props}
            >
                <g
                    clipPath="url(#green-houses-fading_svg__a)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M8.005 30 0 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303H7.47a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H5.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__b)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M32.005 30 24 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H29.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__c)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M56.005 30 48 36.965v15.046h16.01V36.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H53.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__d)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M8.005 0 0 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303H7.47a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H5.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__e)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M32.005 0 24 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H29.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__f)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M56.005 0 48 6.965v15.046h16.01V6.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.656-.765 1.365c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H53.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__g)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M8.005 61 0 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303H7.47a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H5.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__h)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M8.005 92 0 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H5.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.67.67 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__i)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M8.005 122 0 128.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H5.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__j)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M8.005 152 0 158.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H5.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__k)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M8.005 182 0 188.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H5.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__l)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M8.005 212 0 218.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H5.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__m)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M32.005 61 24 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H29.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__n)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M32.005 92 24 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H29.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.67.67 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__o)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M32.005 122 24 128.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H29.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__p)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M32.005 152 24 158.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H29.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__q)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M32.005 182 24 188.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H29.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__r)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M32.005 212 24 218.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H29.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__s)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M56.005 61 48 67.965v15.046h16.01V67.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.42-.943 1.657-.765 1.364c-.115.184-.22.38-.325.564a.62.62 0 0 1-.408.303h-.126a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.153H53.29a.6.6 0 0 1-.306-.091.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.66.66 0 0 1 .127.386v3.152h1.561c.11 0 .218.031.312.089a.63.63 0 0 1 .226.24.66.66 0 0 1-.014.646"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__t)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M56.005 92 48 98.965v15.046h16.01V98.965zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H53.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.66.66 0 0 1 .304-.27.63.63 0 0 1 .398-.033c.13.04.243.12.324.231a.67.67 0 0 1 .127.386v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__u)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M56.005 122 48 128.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H53.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__v)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M56.005 152 48 158.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H53.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__w)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M56.005 182 48 188.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H53.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <g
                    clipPath="url(#green-houses-fading_svg__x)"
                    opacity={0.8}
                >
                    <path
                        fill="#18F0B8"
                        d="M56.005 212 48 218.965v15.046h16.01v-15.046zm3.238 12.381c-.126.238-.262.466-.398.704l-.807 1.419-.943 1.657-.765 1.365c-.115.184-.22.379-.325.564a.61.61 0 0 1-.409.303h-.125a.5.5 0 0 1-.325-.087.64.64 0 0 1-.293-.541v-3.152H53.29a.6.6 0 0 1-.306-.092.64.64 0 0 1-.223-.235.67.67 0 0 1-.005-.638c.01 0 .01 0 .01-.01l.399-.694c.262-.476.534-.953.806-1.419l.933-1.657.775-1.365.325-.563a.65.65 0 0 1 .304-.269.62.62 0 0 1 .398-.034c.13.039.243.12.324.232a.66.66 0 0 1 .127.385v3.152h1.561c.11.001.218.031.312.089a.653.653 0 0 1 .212.886"
                    />
                </g>
                <defs>
                    <clipPath id="green-houses-fading_svg__a">
                        <path
                            fill="#fff"
                            d="M0 30h16v22H0z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__b">
                        <path
                            fill="#fff"
                            d="M24 30h16v22H24z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__c">
                        <path
                            fill="#fff"
                            d="M48 30h16v22H48z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__d">
                        <path
                            fill="#fff"
                            d="M0 0h16v22H0z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__e">
                        <path
                            fill="#fff"
                            d="M24 0h16v22H24z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__f">
                        <path
                            fill="#fff"
                            d="M48 0h16v22H48z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__g">
                        <path
                            fill="#fff"
                            d="M0 61h16v22H0z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__h">
                        <path
                            fill="#fff"
                            d="M0 92h16v22H0z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__i">
                        <path
                            fill="#fff"
                            d="M0 122h16v22H0z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__j">
                        <path
                            fill="#fff"
                            d="M0 152h16v22H0z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__k">
                        <path
                            fill="#fff"
                            d="M0 182h16v22H0z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__l">
                        <path
                            fill="#fff"
                            d="M0 212h16v22H0z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__m">
                        <path
                            fill="#fff"
                            d="M24 61h16v22H24z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__n">
                        <path
                            fill="#fff"
                            d="M24 92h16v22H24z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__o">
                        <path
                            fill="#fff"
                            d="M24 122h16v22H24z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__p">
                        <path
                            fill="#fff"
                            d="M24 152h16v22H24z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__q">
                        <path
                            fill="#fff"
                            d="M24 182h16v22H24z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__r">
                        <path
                            fill="#fff"
                            d="M24 212h16v22H24z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__s">
                        <path
                            fill="#fff"
                            d="M48 61h16v22H48z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__t">
                        <path
                            fill="#fff"
                            d="M48 92h16v22H48z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__u">
                        <path
                            fill="#fff"
                            d="M48 122h16v22H48z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__v">
                        <path
                            fill="#fff"
                            d="M48 152h16v22H48z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__w">
                        <path
                            fill="#fff"
                            d="M48 182h16v22H48z"
                        />
                    </clipPath>
                    <clipPath id="green-houses-fading_svg__x">
                        <path
                            fill="#fff"
                            d="M48 212h16v22H48z"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}

GreenHousesFading.Small = GreenHousesFadingSmall
